import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psadetails-grid',
  templateUrl: './psadetails-grid.component.html',
  styleUrls: ['./psadetails-grid.component.css']
})
export class PsadetailsGridComponent implements OnInit {
  title ="PSA Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psadetails-grid/psadetails-grid.component.ts